<template>
    <div>
        <b-row>
            <b-col sm="12" md="4" lg="4" xl="3">
                <b-form-group>
                    <label>Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do contrato"
                            v-model="contrato"
                            v-mask="'AA###/##'"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3" v-if="mostrarFiltroProcesso">
                <b-form-group>
                    <label>Processo</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do processo"
                            v-model="processo"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="3" v-if="mostrarFiltroDocumento">
                <b-form-group>
                    <label>Documento</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do documento"
                            v-model="documento"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="4"
                lg="4"
                xl="3"
                v-if="mostrarFiltroComprometimento && comprometimentoBool"
            >
                <b-form-group>
                    <label>Comprometimento</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o número do comprometimento"
                            v-model="comprometimento"
                            v-mask="'##########'"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" lg="2" xl="2" v-if="mostrarFiltroStatusComprometimentos && statusComprometimentos">
                <b-form-group>
                    <label>Status do Comprometimento</label>
                    <b-form-select
                        :plain="true"
                        :options="statusComprometimentos"
                        text-field="descricao"
                        value-field="statusId"
                        v-model="statusComprometimento"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" lg="2" xl="2" v-if="mostrarFiltroStatusComprometimentos && statusContratos">
                <b-form-group>
                    <label>Status do Contrato</label>
                    <b-form-select
                        :plain="true"
                        :options="statusContratos"
                        text-field="descricao"
                        value-field="statusId"
                        v-model="statusContrato"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" lg="4" xl="4" v-if="responsaveis">
                <b-form-group>
                    <label>Gestor/Solicitante</label>
                    <b-form-select
                        :plain="true"
                        :options="responsaveis"
                        text-field="nome"
                        value-field="codFuncionario"
                        v-model="responsavel"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="4"
                lg="4"
                xl="4"
                v-if="unidades && mostrarFiltroUnidade"
            >
                <b-form-group>
                    <label>Unidade do Contrato</label>
                    <b-form-select
                        :plain="true"
                        :options="unidades"
                        text-field="nome"
                        value-field="codUnidade"
                        v-model="unidade"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="4" v-if="fornecedores">
                <b-form-group>
                    <label>Fornecedor</label>
                    <b-form-select
                        :plain="true"
                        :options="fornecedores"
                        text-field="nome"
                        value-field="codFornecedor"
                        v-model="fornecedor"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDataMovimento"
            >
                <b-form-group>
                    <label>Data do Movimento (DE)</label>
                    <date-picker
                        v-model="dataMovimentoDe"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDataMovimento"
            >
                <b-form-group>
                    <label>Data do Movimento (ATÉ)</label>
                    <date-picker
                        v-model="dataMovimentoAte"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDatasInicioFim"
            >
                <b-form-group>
                    <label>Data Início (DE)</label>
                    <date-picker
                        v-model="dataInicioDe"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDatasInicioFim"
            >
                <b-form-group>
                    <label>Data Início (ATÉ)</label>
                    <date-picker
                        v-model="dataInicioAte"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDatasInicioFim"
            >
                <b-form-group>
                    <label>Data Fim (DE)</label>
                    <date-picker
                        v-model="dataFimDe"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltroDatasInicioFim"
            >
                <b-form-group>
                    <label>Data Fim (ATÉ)</label>
                    <date-picker
                        v-model="dataFimAte"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4" v-if="mostrarFiltroApenasAtivos || mostrarFiltrosConsumoRequisicao">
                <b-form-group>
                    <b-checkbox v-model="apenasAtivos" class="mt-4 pt-2"
                        >Apenas Contratos Ativos</b-checkbox
                    >
                </b-form-group>
            </b-col>
            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltrosConsumoRequisicao"
            >
                <b-form-group>
                    <label>Data Requisição (De)</label>
                    <date-picker
                        v-model="dataRequisicaoDe"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>

            <b-col
                sm="12"
                md="3"
                lg="3"
                xl="3"
                v-if="mostrarFiltrosConsumoRequisicao"
            >
                <b-form-group>
                    <label>Data Requisição (Até)</label>
                    <date-picker
                        v-model="dataRequisicaoAte"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    props: {
        responsaveis: {
            type: Array
        },
        unidades: {
            type: Array
        },
        fornecedores: {
            type: Array
        },
        tiposFiltros: {
            type: String
        },
        statusComprometimentos: {
            type: Array
        },
        statusContratos: {
            type: Array
        },
        statusConsumoItens: {
            type: Array
        },
        comprometimentoBool: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            contrato: null,
            responsavel: null,
            unidade: null,
            fornecedor: null,
            dataMovimentoDe: null,
            dataMovimentoAte: null,
            processo: null,
            documento: null,
            comprometimento: null,
            statusComprometimento: null,
            statusContrato: null,
            dataInicioDe: null,
            dataInicioAte: null,
            dataFimDe: null,
            dataFimAte: null,
            apenasAtivos: false,
            dataRequisicaoDe: null,
            dataRequisicaoAte: null,
        }
    },

    computed: {
        filtro() {
            let retorno = {
                contrato: this.contrato,
                responsavel: this.responsavel,
                unidade: this.unidade,
                fornecedor: this.fornecedor,
                dataMovimentoDe: this.dataMovimentoDe
                    ? this.$moment(this.dataMovimentoDe, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataMovimentoAte: this.dataMovimentoAte
                    ? this.$moment(this.dataMovimentoAte, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                processo: this.processo,
                documento: this.documento,
                comprometimento: this.comprometimento,
                statusComprometimento: this.statusComprometimento,
                dataInicioDe: this.dataInicioDe
                    ? this.$moment(this.dataInicioDe, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataInicioAte: this.dataInicioAte
                    ? this.$moment(this.dataInicioAte, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataFimDe: this.dataFimDe
                    ? this.$moment(this.dataFimDe, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataFimAte: this.dataFimAte
                    ? this.$moment(this.dataFimAte, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                apenasAtivos: this.apenasAtivos,
                dataRequisicaoDe: this.dataRequisicaoDe
                    ? this.$moment(this.dataRequisicaoDe, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataRequisicaoAte: this.dataRequisicaoAte
                    ? this.$moment(this.dataRequisicaoAte, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
            }
            return retorno
        },

        mostrarFiltroProcesso() {
            if (this.tiposFiltros && this.tiposFiltros.includes('p')) {
                return true
            }
            return false
        },

        mostrarFiltroDocumento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('d')) {
                return true
            }
            return false
        },

        mostrarFiltroComprometimento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('c')) {
                return true
            }
            return false
        },

        mostrarFiltroStatusComprometimentos() {
            if (this.tiposFiltros && this.tiposFiltros.includes('s')) {
                return true
            }
            return false
        },

        mostrarFiltroUnidade() {
            if (this.tiposFiltros && this.tiposFiltros.includes('u')) {
                return true
            }
            return false
        },

        mostrarFiltroDataMovimento() {
            if (this.tiposFiltros && this.tiposFiltros.includes('m')) {
                return true
            }
            return false
        },

        mostrarFiltroDatasInicioFim() {
            if (this.tiposFiltros && this.tiposFiltros.includes('i')) {
                return true
            }
            return false
        },

        mostrarFiltroApenasAtivos() {
            if (this.tiposFiltros && this.tiposFiltros.includes('a')) {
                return true
            }
            return false
        },

        mostrarFiltrosConsumoRequisicao() {
            if (this.tiposFiltros && this.tiposFiltros.includes('cr')) {
                return true
            }
            return false
        }
    },

    watch: {
        contrato() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        responsavel() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        unidade() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        fornecedor() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataMovimentoDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataMovimentoAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        processo() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        documento() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        comprometimento() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        statusComprometimento() {
            this.$emit('filtroAtualizado', this.filtro)
        },
        
        statusContrato() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataInicioDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataInicioAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataFimDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataFimAte() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        apenasAtivos() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataRequisicaoDe() {
            this.$emit('filtroAtualizado', this.filtro)
        },

        dataRequisicaoAte() {
            this.$emit('filtroAtualizado', this.filtro)
        }
    }
}
</script>
